import axiosInstance from "@/api/axios-instance";

export async function updateBundleUsageStatus(usage_id: string, status: string) {
  const response = await axiosInstance.patch("/usage/update-bundle-status", {
    usage_id,
    status
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("failed updating exception");
  }

  const data = response.data;
  return data;
}